import { SVGProps, Ref, forwardRef } from 'react';

export const CalendarOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.299 1.712C1.202 2.226.554 3.855.5 8.5c.07 6.105 1.169 7 7.5 7s7.43-.895 7.5-7c-.054-4.647-.703-6.276-3.803-6.788V.5h-1.4v1.06A36 36 0 0 0 8 1.5c-.86 0-1.624.017-2.301.06V.5h-1.4zm0 1.423v1.364h1.4V2.963A34 34 0 0 1 8 2.9c.894 0 1.651.019 2.297.063V4.5h1.4V3.134c.782.154 1.198.373 1.454.608.258.237.498.624.672 1.396q.082.368.14.827H2.037q.056-.458.14-.827c.173-.772.413-1.16.671-1.396.255-.235.67-.454 1.45-.607m-2.37 4.23Q1.909 7.888 1.9 8.5c.018 1.498.1 2.573.277 3.362.174.772.414 1.16.672 1.396.268.246.712.475 1.566.629.864.156 2.015.213 3.585.213s2.72-.057 3.585-.213c.854-.154 1.298-.383 1.566-.629.258-.237.498-.624.672-1.396.177-.79.26-1.864.277-3.362a37 37 0 0 0-.03-1.135z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
CalendarOutlinedSize16Glyph.displayName = 'CalendarOutlinedSize16Glyph';
